<template>
  <div class="cart-wrap ptb-100">
    <div class="container">
      <div class="cart-table">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Product
              </th>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Price
              </th>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Availability
              </th>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Add To Cart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="product-item">
                  <button class="cart-action" type="button">
                    <img src="../../assets/img/icons/close.svg" alt="Image" />
                  </button>
                  <div
                    class="product-img d-flex flex-column align-items-center justify-content-center"
                  >
                    <img
                      src="../../assets/img/shop/product-thumb-1.webp"
                      alt="Image"
                    />
                  </div>
                  <router-link
                    class="cart-item f-secondary text_secondary"
                    to="/product-details"
                  >
                    <span>Cat Fish Food</span>
                  </router-link>
                </div>
              </td>
              <td class="text_secondary">$59.00</td>
              <td>In Stock</td>
              <td>
                <button class="btn style-one">Add To Cart</button>
              </td>
            </tr>
            <tr>
              <td>
                <div class="product-item">
                  <button class="cart-action" type="button">
                    <img src="../../assets/img/icons/close.svg" alt="Image" />
                  </button>
                  <div
                    class="product-img d-flex flex-column align-items-center justify-content-center"
                  >
                    <img
                      src="../../assets/img/shop/product-thumb-2.webp"
                      alt="Image"
                    />
                  </div>
                  <router-link
                    class="cart-item f-secondary text_secondary"
                    to="/product-details"
                  >
                    <span>Can Food</span>
                  </router-link>
                </div>
              </td>
              <td class="text_secondary">$56.00</td>
              <td>In Stock</td>
              <td>
                <button class="btn style-one">Add To Cart</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-md-5 offset-md-7 text-sm-end">
          <router-link
            to="/shop"
            class="btn style-four update-cart"
            type="button"
          >
            Continue Shopping
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WishlistContent",
};
</script>